<template v-if="skin">
  <div>
    <v-slide-x-transition :leave-absolute="true" :hide-on-leave="true">
      <template v-if="!showInput && !inputOnly">
        <v-btn v-if="$isDesktopDevice" @click="showInput = true" :color="skin.primary_color"
          class="subPrimary--text ml-0" :key="1">

          <v-icon left>compare_arrows</v-icon>

          <span class="font-weight-light text-capitalize">{{ $t('Interchange.Title') }}</span>
        </v-btn>

        <v-btn v-if="$isMobileDevice" @click="showInput = true" :color="skin.primary_color" fab small dark>
          <v-icon medium color="subPrimary">compare_arrows</v-icon>
        </v-btn>
      </template>

      <template v-if="showInput || inputOnly">
        <v-flex d-flex shrink :key="2">
          <v-form v-model="isValid" :lazy-validation="true" @submit.prevent="searchInterchange($event)"
            ref="interchangeForm">
            <v-text-field flat required autofocus :rules="interchangeRules" @blur="onBlurInterchange" ref="interchange"
              :label="$t('Interchange.Labels.Hint')" :color="skin.primary_color" class="interchangeInput mx-3"
              v-model="inputSearch"></v-text-field>
          </v-form>

          <v-btn :disabled="!isValid || !this.inputSearch" class="mx-0" small fab icon
            :title="$t('Interchange.Labels.Search')" @click="searchInterchange($event)">
            <v-icon medium>search</v-icon>
          </v-btn>

          <v-btn :title="$t('Interchange.Labels.HintHelp')" fab small icon @click="showHelp" class="mx-0">
            <v-icon medium>help_outline</v-icon>
          </v-btn>

          <v-btn class="mx-0" small fab icon :title="$t('Interchange.Actions.Close')" @click="showInput = false"
            v-if="!inputOnly">
            <v-icon medium>cancel</v-icon>
          </v-btn>
        </v-flex>
      </template>
    </v-slide-x-transition>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
export default {
  name: "InterchangeForm",
  props: {
    dark: {
      type: Boolean
    },
    inputOnly: {
      type: Boolean
    }
  },
  data: () => ({
    inputSearch: "",
    isValid: false,
    // eslint-disable-next-line
    wildcards: /[(\?+)(\*+)]/g,
    showInput: false
  }),
  computed: {
    ...mapState({
      skin: state => state.settings.skin
    }),
    interchangeRules() {
      return [
        v =>
          (v && v.charAt(0) !== "*") ||
          this.$i18n.tc("Interchange.Labels.Invalid"),
        v =>
          (v && v.length >= 2) || this.$i18n.tc("Interchange.Labels.MinLength"),
        v =>
          v && v.length === 2 && v.charAt(1) === "*"
            ? this.$i18n.tc("Interchange.Labels.Invalid")
            : true,
        v =>
          v && v.length === 3 && v.charAt(2) === "*"
            ? this.$i18n.tc("Interchange.Labels.LargeResults")
            : true,
        v =>
          v && v.length === 4 && v.charAt(3) === "*"
            ? this.$i18n.tc("Interchange.Labels.LargeResults")
            : true
      ];
    },
    hasWildcards() {
      return (
        this.wildcards.test(this.inputSearch) ||
        this.inputSearch.match(this.wildcards) !== null
      );
    }
  },
  methods: {
    ...mapActions({
      SET_INTERCHANGE_NUM: "interchange/SET_INTERCHANGE_NUM",
      GET_WILDCARD_RESULTS: "interchange/GET_WILDCARD_RESULTS",
      TOGGLE_MODAL_STATE: "modals/TOGGLE_MODAL_STATE",
      GET_INTERCHANGE: "interchange/GET_INTERCHANGE",
      RESET_PART_LIST: "parts/RESET_PART_LIST"
    }),
    onBlurInterchange() {
      if (!this.inputSearch)
        this.$refs.interchangeForm.resetValidation();
    },
    async searchInterchange() {
      this.SET_INTERCHANGE_NUM(this.inputSearch);

      if (!this.isValid || !this.inputSearch) return;

      if (this.hasWildcards) {
        await this.GET_WILDCARD_RESULTS(this.inputSearch);
        this.TOGGLE_MODAL_STATE({ name: "intWildcards", value: true })
      }
      else {
        await this.GET_INTERCHANGE({ interChangeNum: this.inputSearch, page: 1, size: 25});
        this.$root.$emit("close-modal", "intSearch");
      }

      this.RESET_PART_LIST()
    },
    showHelp() {
      this.TOGGLE_MODAL_STATE({
        name: "intHelp",
        value: true
      });
    }
  }
};
</script>

<style lang="stylus" scoped></style>
